module.exports = __webpack_public_path__ + "img/icon_success.2d02fd52.png";